/**
 * Team Colors
 */

export interface TeamColorTheme {
    teamColor1: string;
    teamColor2: string;
    teamColor3?: string;
    teamColor4?: string;
    name?: string;
    abbreviation?: string;
}

export interface TeamThemes {
    [teamId: string]: TeamColorTheme;
}

const TEAM_THEMES: TeamThemes = {
    '109': {
        teamColor1: '#A71930',
        teamColor2: '#E3D4AD',
        teamColor3: '#000000',
        abbreviation: 'ARI'
    },
    '144': {
        teamColor1: '#0D2340',
        teamColor2: '#CE1141',
        teamColor3: '#EAAA00',
        abbreviation: 'ATL'
    },
    '110': {
        teamColor1: '#DF4A20',
        teamColor2: '#000000',
        teamColor3: '#A2AAAD',
        abbreviation: 'BAL'
    },
    '111': {
        teamColor1: '#BC2F38',
        teamColor2: '#0D2B56',
        abbreviation: 'BOS'
    },
    '112': {
        teamColor1: '#0E3386',
        teamColor2: '#CB3433',
        abbreviation: 'CHC'
    },
    '113': {
        teamColor1: '#C6011F',
        teamColor2: '#000000',
        teamColor3: '#041E42',
        abbreviation: 'CIN'
    },
    '114': {
        teamColor1: '#E31937',
        teamColor2: '#002B5C',
        abbreviation: 'CLE'
    },
    '115': {
        teamColor1: '#33006F',
        teamColor2: '#C4CED4',
        teamColor3: '#000000',
        abbreviation: 'COL'
    },
    '145': {
        teamColor1: '#000000',
        teamColor2: '#C4CED4',
        teamColor3: '#0C2340',
        teamColor4: '#C8102E',
        abbreviation: 'CWS'
    },
    '116': {
        teamColor1: '#0C2C56',
        teamColor2: '#FF6600',
        abbreviation: 'DET'
    },
    '117': {
        teamColor1: '#002D62',
        teamColor2: '#EB6E1F',
        teamColor3: '#F4911E',
        abbreviation: 'HOU'
    },
    '118': {
        teamColor1: '#004687',
        teamColor2: '#C09A5B',
        teamColor3: '#7AB2DD',
        abbreviation: 'KC'
    },
    '108': {
        teamColor1: '#BA0021',
        teamColor2: '#862633',
        teamColor3: '#003263',
        abbreviation: 'LAA'
    },
    '119': {
        teamColor1: '#005A9C',
        teamColor2: '#EF3E42',
        teamColor3: '#A2AAAD',
        abbreviation: 'LAD'
    },
    '146': {
        teamColor1: '#000000',
        teamColor2: '#00A3E0',
        teamColor3: '#EF3340',
        abbreviation: 'MIA'
    },
    '158': {
        teamColor1: '#0A2351',
        teamColor2: '#B6922E',
        teamColor3: '#7C2529',
        abbreviation: 'MIL'
    },
    '142': {
        teamColor1: '#002B5C',
        teamColor2: '#D31145',
        teamColor3: '#FFD100',
        abbreviation: 'MIN'
    },
    '121': {
        teamColor1: '#002D72',
        teamColor2: '#FF5910',
        teamColor3: '#888B8D',
        abbreviation: 'NYM'
    },
    '147': {
        teamColor1: '#132448',
        teamColor2: '#003087',
        teamColor3: '#E4002C',
        teamColor4: '#C4CED4',
        abbreviation: 'NYY'
    },
    '133': {
        teamColor1: '#003831',
        teamColor2: '#EFB21E',
        abbreviation: 'OAK'
    },
    '143': {
        teamColor1: '#E81828',
        teamColor2: '#003278',
        abbreviation: 'PHI'
    },
    '134': {
        teamColor1: '#FDB827',
        teamColor2: '#000000',
        teamColor3: '#EE3A42',
        abbreviation: 'PIT'
    },
    '135': {
        teamColor1: '#FFC425',
        teamColor2: '#2E241D',
        abbreviation: 'SD'
    },
    '136': {
        teamColor1: '#0C2C56',
        teamColor2: '#005D5C',
        teamColor3: '#C4CED4',
        abbreviation: 'SEA'
    },
    '137': {
        teamColor1: '#FD5A1E',
        teamColor2: '#000000',
        abbreviation: 'SF'
    },
    '138': {
        teamColor1: '#C41E3A',
        teamColor2: '#000066',
        teamColor3: '#FEDB00',
        abbreviation: 'STL'
    },
    '139': {
        teamColor1: '#092C5C',
        teamColor2: '#8FBCE6',
        teamColor3: '#F5D130',
        abbreviation: 'TB'
    },
    '140': {
        teamColor1: '#003278',
        teamColor2: '#C0111F',
        abbreviation: 'TEX'
    },
    '141': {
        teamColor1: '#134A8E',
        teamColor2: '#1D2D5C',
        teamColor3: '#E8291C',
        abbreviation: 'TOR'
    },
    '120': {
        teamColor1: '#AB0003',
        teamColor2: '#11225B',
        abbreviation: 'WSH'
    }
};

export default TEAM_THEMES;
